export default __webpack_public_path__ + "static/Myrch_Texture_Instagram@2x-67a440bb8db3b88237a2354b3fe36f33.jpg";